module.exports = __webpack_public_path__ + "static/media/21ECLAC9.fe3ae590.jpg";